'use client'
import { type FC } from 'react'
import styled from 'styled-components'
import { useTranslator } from '@/hooks'
import { Link } from './commons'
import { createUnderline, designGrid, getP50, mq, vw } from '@/styles'

export const SectionFitsIntoYourProject:FC = () => {
  const { t } = useTranslator()

  return (
    <Section>
      <h2 dangerouslySetInnerHTML={{ __html: t('project.product.section_fits.title') as string }}></h2>
      <Link href='/contact'>
        {t('project.product.section_fits.contact_us')}
      </Link>
    </Section>
  )
}

const Section = styled.section`
  ${designGrid({})}
  padding: ${vw(130, 'mobile')} 0;
  padding: 0 12px;
  width: 100vw;
  width: 100dvw;

  ${mq.greaterThan('tablet')} {
    padding: ${vw(150, 'desktop')} 0;
  }

  h2 {
    ${getP50()}
    width: 100%;
    margin-bottom: ${vw(20, 'mobile')};

    ${mq.greaterThan('tablet')} {
      margin-bottom: ${vw(40, 'desktop')};
    }
  }

  h2,
  a {
    grid-column: 1 / span 6;
    justify-self: center;
    text-align: center;

    ${mq.greaterThan('tablet')} {
      grid-column: 2 / span 10;
    }
  }

  a {
    ${createUnderline({ reverse: true })}
    width: auto;
    width: fit-content;
  }
`